/* eslint-disable */

import React, { useEffect, useState } from 'react'

import SearchIcon from '@mui/icons-material/Search'
import {
  Backdrop,
  CircularProgress,
  InputAdornment,
  TextField,
  Tooltip
} from '@mui/material'
import TablePagination, {
  tablePaginationClasses as classes
} from '@mui/material/TablePagination'
import { styled } from '@mui/system'
import {
  EMULATOR_NOTIFICATION_URL,
  TRIP_HISTORY,
  TRIP_TOGGLE,
  TRIP_TOGGLES
} from '../../../constants'

import {
  MAXIMUM_VELOCITY_METERS_PER_MILLISECONDS,
  MINIMUM_VELOCITY_METERS_PER_MILLISECONDS
} from '../../../MetricsConstants.js'

// icons
import CheckCircleOutlineIcon from '@mui/icons-material/CheckCircleOutline'
import HistoryIcon from '@mui/icons-material/History'
// import MessageRoundedIcon from '@mui/icons-material/MessageRounded'
import PauseCircleOutlineIcon from '@mui/icons-material/PauseCircleOutline'
import PlayCircleOutlineIcon from '@mui/icons-material/PlayCircleOutline'
import RestartAltIcon from '@mui/icons-material/RestartAlt'
import IconButton from '@mui/material/IconButton'

// components
import ContactDialogComponent from './Phone/ContactDialogComponent'

import ApiService from '../../../ApiService'
import PopUpEmulatorHistory from './popup_emulator_history'

import OptimizedFilter from 'react-optimized-filter'
import { useLocation } from 'react-router-dom'
import { useStates } from '../../../StateProvider'
import { useViewPort } from '../../../ViewportProvider'
import '../../../css/emulator_list_row.css'
import '../../../scss/gps.scss'
import { compareSelectedDeviceForDialog } from '../../../stores/call/storeCall.tsx'
import { useEmulatorStore } from '../../../stores/emulator/store.tsx'
import AddressTable from './Address/AddressTable.js'
// import CustomNoteComponent from './Phone/CustomNoteComponent.js'

const GpsTable = () => {
  // FIXME: fix table rerendering.
  const fetchEmulators = useEmulatorStore((state) => state.fetchEmulators)
  const [searchInput, setSearchInput] = useState('')

  const [mobileInput, setMobileInput] = useState('')
  const emulators = useEmulatorStore((state) => state.emulators)

  const selectedEmulator = useEmulatorStore((state) => state.selectedEmulator)

  const selectEmulator = useEmulatorStore((state) => state.selectEmulator)

  const selectDevice = useEmulatorStore((state) => state.selectDevice)

  const devices = useEmulatorStore((state) => state.devices)

  const hoveredEmulator = useEmulatorStore((state) => state.hoveredEmulator)

  // MULTIPLE ROUTE_DATA
  const setDefaultTripPoints = useEmulatorStore(
    (state) => state.setDefaultPathPoints
  )
  const setAlternativeTripPoints = useEmulatorStore(
    (state) => state.setAlternativePathPoints
  )

  const setSelectedRouteDetailsSubmit = useEmulatorStore(
    (state) => state.setSelectedRouteDetails
  )

  // get ssid from data page
  const location = useLocation()
  const getSSID = location.state?.ssid

  // State variables
  const { staticEmulators, showToast } = useStates()

  const { width, height } = useViewPort()
  const breakpoint = 620

  const isMobile = width < breakpoint

  const [page, setPage] = useState(0)
  const [rowsPerPage, setRowsPerPage] = useState(1)
  const [messageLoading, setMessageLoading] = useState(false)

  const [openEmulatorHistoryPopUp, setOpenEmulatorHistoryPopUp] =
    useState(false)

  const [selectedEmulatorForHistoryData, setSelectedEmulatorForHistoryData] =
    useState(null)

  const handleHistoryClose = () => {
    setOpenEmulatorHistoryPopUp(false)
    setSelectedEmulatorForHistoryData(null)
  }
  // const [selectedEmulatorId, setSelectedEmulatorId] = useState(null);
  // const [hours, setHours] = useState(0);
  // const [minutes, setMinutes] = useState(0);

  // const handleSubmitDelay = (emulator) => {
  //   const delayInMillis = (Number(hours) * 60 * 60 + Number(minutes) * 60) * 1000;
  //   if (delayInMillis <= 0) {
  //     showToast('Please select a non-zero delay time', 'error');
  //     return;
  //   }
  //   handleActionButtonClick(emulator, delayInMillis);
  //   setSelectedEmulatorId(null); // close dropdown after action
  // };

  const [contactDialogOptions, setContactDialogOptions] = useState({
    open: false,
    dialogType: '',
    emulatorId: null
  })

  const selectedDevice = useEmulatorStore(
    (state) => state.selectedDevice,
    (oldSelectedDevice, newSelectedDevice) =>
      compareSelectedDeviceForDialog(oldSelectedDevice, newSelectedDevice)
  )

  useEffect(() => {
    // When call comes/ ends.
    if (selectedDevice === null || selectedDevice.state === null) {
      setContactDialogOptions({
        open: false,
        dialogType: '',
        emulatorId: null
      })
    } else if (selectedDevice.state === 'Incoming') {
      setContactDialogOptions({
        open: true,
        dialogType: 'call',
        emulatorId: null
      })
    } else if (selectedDevice.state === 'On call') {
      setContactDialogOptions({
        open: true,
        dialogType: 'call',
        emulatorId: null
      })
    } else if (
      selectedDevice.state === 'Offline' ||
      selectedDevice.state === 'Ready'
    ) {
      setContactDialogOptions({
        open: false,
        dialogType: '',
        emulatorId: null
      })
    }
  }, [selectedDevice])

  const handleCallIconClicked = (emulator) => {
    const device = devices.find((device) => device.emulatorId === emulator.id)
    selectDevice(device)
    setContactDialogOptions({
      open: true,
      dialogType: 'call',
      emulatorId: null
    })
  }

  const handleMessageIconClicked = (row) => {
    setContactDialogOptions({
      open: true,
      dialogType: 'message',
      emulatorId: row.id
    })
  }

  useEffect(() => {
    if (hoveredEmulator !== null) {
    console.log('current Page', page)
      const selectedEmIndex = emulators.findIndex(
        (emulator) => emulator.id === hoveredEmulator.id
      )
      // Calculate the new active page based on the selected checkbox index and rowsPerPage
      if (selectedEmIndex !== -1) {
        const newActivePage = Math.floor(selectedEmIndex / rowsPerPage)
        setPage(newActivePage)
      }
    } else if (selectedEmulator !== null) {
      const selectedEmIndex = emulators.findIndex(
        (emulator) => emulator.id === selectedEmulator.id
      )
      console.log('selectedEmIndex', selectedEmIndex)
      // Calculate the new active page based on the selected checkbox index and rowsPerPage
      if (selectedEmIndex !== -1) {
        const newActivePage = Math.floor(selectedEmIndex / rowsPerPage)
        setPage(newActivePage)
      }
    }
    console.log('updated Page', page)
    // FIXME: temporary fix for table rerendering
  }, [selectedEmulator, hoveredEmulator, rowsPerPage])

  // page changed from arrows
  useEffect(() => {
    if (tablePaginationRef.current) {
      tablePaginationRef.current.setPage(page)
    }
  }, [page])

  const tablePaginationRef = React.useRef(null)
  // get max rows we can get within the screen height - 128px(navbar) - 55px(search) - 50px(footer/pagination)
  useEffect(() => {
    const maxRowsPerPage = Math.floor((height - 128 - 55 - 50) / 80)
    tablePaginationRef.current?.setRowsPerPage(maxRowsPerPage)
    setRowsPerPage(maxRowsPerPage)
  }, [height])

  useEffect(() => {
    // Retrieve selected emulator from local storage
    const storedSelectedEmulatorStr = localStorage.getItem('selectedEmulator')
    let storedSelectedEmulator
    if (
      typeof storedSelectedEmulatorStr === 'string' &&
      storedSelectedEmulatorStr !== '[object Object]' &&
      storedSelectedEmulatorStr !== 'undefined' &&
      storedSelectedEmulatorStr !== undefined
    ) {
      storedSelectedEmulator = JSON.parse(storedSelectedEmulatorStr)

      if (storedSelectedEmulator) {
        selectEmulator(storedSelectedEmulator)
      }
    }
  }, []) // Empty dependency array to run the effect only once when the component mounts

  useEffect(() => {
    const ssidToString = selectedEmulator
      ? selectedEmulator?.emulatorSsid.toString()
      : ''
    if (isMobile) {
      setMobileInput(ssidToString)
    }
  }, [selectedEmulator, isMobile])

  const handleEmulatorCheckboxChange = (emulatorRow) => {
    if (selectedEmulator?.id !== emulatorRow?.id) {
      selectEmulator(emulatorRow)
      localStorage.setItem('selectedEmulator', JSON.stringify(emulatorRow))

      // when selecting any other emualtor clear the previous saved zoom and center
      // for zoom functionality while refreshing the page
      localStorage.removeItem('mapZoom')
      localStorage.removeItem('mapCenter')
    } else {
      selectEmulator(null)
      // Remove the selected emulator ID from local storage
      localStorage.removeItem('selectedEmulator')
      // Remove the previous selected zoom and center.
      localStorage.removeItem('mapZoom')
      localStorage.removeItem('mapCenter')
    }
    setDefaultTripPoints(0)
    setAlternativeTripPoints([0])
    const updatedSelectedRouteDetails = {
      alternativeRoute: ''
    }
    setSelectedRouteDetailsSubmit(updatedSelectedRouteDetails)
  }

  useEffect(() => {
    const selectedEmulatorSSID = emulators?.filter(
      (data) => data?.emulatorSsid === getSSID
    )
    if (selectedEmulatorSSID.length > 0) {
      handleEmulatorCheckboxChange(selectedEmulatorSSID[0])
    }
  }, [getSSID])

  const handleHistoryButtonClick = async (emulatorForHistory) => {
    setMessageLoading(true)
    const token = localStorage.getItem('token')
    const { success, data, error } = await ApiService.makeApiCall(
      TRIP_HISTORY + '/' + emulatorForHistory.id,
      'GET',
      null,
      token
    )
    if (success) {
      setMessageLoading(false)
      setSelectedEmulatorForHistoryData(data)
      setOpenEmulatorHistoryPopUp(true)
    } else {
      console.error(`Error Fetching History : ${error}`)
      showToast('Error Fetching History', 'error')
    }
  }

  const handleRestartButtonClick = async (row) => {
    const token = localStorage.getItem('token')
    const { success, error } = await ApiService.makeApiCall(
      EMULATOR_NOTIFICATION_URL + '/' + row.id,
      'POST',
      null,
      token
    )
    if (success) {
      showToast('Notification send', 'success')
    } else {
      console.error(`Error sending notification : ${error}`)
      showToast('Error', 'error')
    }
  }

  const handleActionButtonClick = async (row, event) => {
  event.preventDefault();          // Prevent default browser action
  event.stopPropagation();         // Prevent bubbling to parent elements

  if (row.tripStatus === 'FINISHED') {
    showToast('Trip already Finished!', 'error');
    return;
  }

  const currentStatus = row.tripStatus;
  const token = localStorage.getItem('token');

    // Prompt after pausing
    const hoursInput = prompt('Enter delay hours:', '0');
    const minutesInput = prompt('Enter delay minutes:', '0');

    const hours = Number(hoursInput);
    const minutes = Number(minutesInput);

    if (isNaN(hours) || isNaN(minutes)) {
      showToast('Invalid input. Please enter numeric values.', 'error');
      return;
    }
   const delayInMillis = (hours * 60 * 60 + minutes * 60) * 1000;

    if (delayInMillis <= 0) {
      showToast('Please select a non-zero delay time', 'error');
      return;
    }

    const pausePayload = {
      emulatorId: row.id,
      status: 'PAUSED',
      delayInMillis: delayInMillis, // Immediate pause
    };

    const pauseResult = await ApiService.makeApiCall(
      TRIP_TOGGLES,
      'POST',
      pausePayload,
      token
    );

    if (pauseResult.success) {
      showToast('Trip paused immediately.', 'info');
      fetchEmulators();

    } else {
      showToast('Error pausing the trip.', 'error');
    }
    return; // exit here
};




  const isVelocityOutOfRange = (velocity) =>
    velocity < MINIMUM_VELOCITY_METERS_PER_MILLISECONDS ||
    velocity > MAXIMUM_VELOCITY_METERS_PER_MILLISECONDS

  const isSelectedEmulator = (emulatorId, selectedEmulator) =>
    emulatorId === selectedEmulator?.id

  const isHoveredEmulator = (emulatorId, hoveredEmulator) =>
    emulatorId === hoveredEmulator?.id

  const getBlinkClass = (emulator, selectedEmulator, hoveredEmulator) => {
    if (
      !isSelectedEmulator(emulator.id, selectedEmulator) &&
      !emulator.startLat
    ) {
      return ''
    }
    if (isVelocityOutOfRange(emulator.velocity)) {
      if (isSelectedEmulator(emulator.id, selectedEmulator)) {
        return 'blink-selected'
      }
      if (isHoveredEmulator(emulator.id, hoveredEmulator)) {
        return 'blink-hovered'
      }
      return 'blink'
    }
    return ''
  }

  const handleChangeInput = (e) => {
    setMobileInput('')
    setSearchInput(e.target.value)
  }

  return (
    <div className="main-gps-page-table">
      <div className="address-table-main">
        <AddressTable />
      </div>
      <div>
        <Backdrop color="primary" style={{ zIndex: 4 }} open={messageLoading}>
          <CircularProgress color="primary" />
        </Backdrop>
        <div
          style={{
            display: 'flex',
            flexDirection: 'column',
            position: isMobile ? 'static' : 'static',
            top: isMobile ? '0px' : '0px',
            width: isMobile ? '257px' : '257px',
            marginLeft: isMobile ? '0px' : '0px',
            padding: '12px'
          }}
        >
          <>
            <TextField
              style={{
                height: isMobile ? '55px' : '55px',
                minHeight: isMobile ? '55px' : '55px',
                maxHeight: isMobile ? '55px' : '55px',
                margin: '0'
              }}
              placeholder="Search by Number/Note/Ssid"
              value={searchInput}
              onChange={(e) => handleChangeInput(e)}
              InputProps={{
                startAdornment: (
                  <InputAdornment position="start">
                    <SearchIcon />
                  </InputAdornment>
                ),
                sx: {
                  borderRadius: '10px', // Ensures rounded corners inside InputProps
                  backgroundColor: '#fff', // Optional: Keeps background clean
                  '& .MuiOutlinedInput-notchedOutline': {
                    borderColor: '#ccc' // Default border color
                  },
                  '&:hover .MuiOutlinedInput-notchedOutline': {
                    borderColor: '#212529' // Border color on hover
                  },
                  '&.Mui-focused .MuiOutlinedInput-notchedOutline': {
                    borderColor: '#212529' // Border color when focused
                  },
                  height: '40px',
                  '&::placeholder': {
                    fontSize: '12px' // Set placeholder font size
                  },
                  '& input::placeholder': {
                    fontSize: '11px', // Ensures it works in all cases
                    fontWeight: '400',
                    fontFamily: "'Poppins', sans-serif"
                  }
                }
              }}
            />
            <div className="gps-page-table-scoll-bar">
              <OptimizedFilter
                items={emulators}
                predicate={(emulator, index, predicateArg) => {
                  if (predicateArg.length !== 0) setPage(0)
                  // Determine if item should be included in filtered list... checking ssid and note
                  return (
                    emulator.emulatorSsid.includes(predicateArg) ||
                    (emulator.telephone &&
                      emulator.telephone.includes(predicateArg)) ||
                    (emulator.note &&
                      emulator.note
                        .toLowerCase()
                        .includes(predicateArg.toLowerCase()))
                  )
                }}
                predicateArg={mobileInput || searchInput}
                render={(emulators) => (
                  // Render filtered items...
                  <table
                    style={{
                      width: '100%',
                      borderCollapse: 'separate',
                      borderSpacing: '0px', // Removes any gaps
                      outline: 'none', // Ensures no table outline
                      border: 'none' // Removes table border
                    }}
                  >
                    <tbody>
                      {(rowsPerPage > 0
                        ? emulators.slice(
                            page * rowsPerPage,
                            page * rowsPerPage + rowsPerPage
                          )
                        : emulators
                      )?.map((emulator, index) => (
                        <tr
                          key={emulator.id || 'N/A'}
                          style={{
                            height: isMobile ? '100px' : '100px',
                            minHeight: isMobile ? '100px' : '100px',
                            maxHeight: isMobile ? '100px' : '100px',
                            border: '2px solid #E6E6E6',
                            borderRadius: '20px',
                            width: '10px',
                            position: 'relative'
                          }}
                          className={`${getBlinkClass(
                            emulator,
                            selectedEmulator,
                            hoveredEmulator
                          )} ${
                            isSelectedEmulator(emulator.id, selectedEmulator)
                              ? 'selected'
                              : ''
                          } ${
                            isHoveredEmulator(emulator.id, hoveredEmulator)
                              ? 'hovered'
                              : ''
                          }`}
                          onClick={() => handleEmulatorCheckboxChange(emulator)}
                        >
                          {/* <td
                          style={{
                            background:
                              emulator.status === 'ACTIVE'
                                ? '#16BA00'
                                : emulator.status === 'INACTIVE'
                                  ? '#FFA500'
                                  : '#ff4d4d',
                            textAlign: 'center'
                          }}
                        > */}
                          {/* Restart/Reset Button */}
                          {/* <RestartAltIcon
                            fontSize="small"
                            onClick={() => handleRestartButtonClick(emulator)}
                          /> */}
                          {/* </td> */}

                          <td
                            style={{
                              borderRadius: '10px',
                              border: '1px solid #E6E6E6'
                            }}
                          >
                            <div className="emulator-gps">
                              {/* Emulator icons */}
                              <td>
                                {emulator.status === 'ACTIVE' ? (
                                  <img
                                    src={'images/gps/emulator-active-icon.svg'}
                                    alt="emulator-active-icon"
                                  />
                                ) : emulator.status === 'INACTIVE' ? (
                                  <img
                                    src={'images/gps/emulator-rest-icon.svg'}
                                    alt="emulator-rest-icon"
                                  />
                                ) : (
                                  <img
                                    src={'images/gps/emulator-default-icon.svg'}
                                    alt="emulator-default-icon"
                                  />
                                )}
                              </td>
                              <td className="alignEmuName custom-font-gps-table">
                                {emulator?.user
                                  ? emulator?.user?.firstName +
                                    ' ' +
                                    emulator?.user?.lastName
                                  : 'NA'}
                              </td>

                              {/* Emulator status icon */}
                              <td className="align-emulator-icon">
                                {emulator.status === 'ACTIVE' ? (
                                  <img
                                    src={
                                      'images/gps/circle-shows-emulator-active.svg'
                                    }
                                    alt="circle-shows-emulator-active"
                                  />
                                ) : emulator.status === 'INACTIVE' ? (
                                  <img
                                    src={
                                      'images/gps/circle-shows-emulator-inactive.svg'
                                    }
                                    alt="circle-shows-emulator-inactive"
                                  />
                                ) : (
                                  <img
                                    src={
                                      'images/gps/circle-shows-emulator-rest.svg'
                                    }
                                    alt="circle-shows-emulator-rest"
                                  />
                                )}
                              </td>
                            </div>

                            <div className="emulator-gps-sub-details">
                              {/* TELEPHONE */}
                              <td>
                                <div
                                  style={{
                                    width: '100%',
                                    display: 'flex',
                                    flexDirection: 'column',
                                    alignItems: 'center'
                                  }}
                                >
                                  <Tooltip
                                    title={emulator?.emulatorSsid || 'N/A'}
                                    placement="top"
                                  >
                                    <div
                                      style={{
                                        display: 'flex',
                                        alignItems: 'center'
                                      }}
                                    >
                                      <div className="alignSsid custom-font-gps-table-ssid">
                                        {emulator?.emulatorSsid || 'N/A'}
                                      </div>
                                    </div>
                                  </Tooltip>
                                  {/* custom notes */}
                                  {/* <div style={{ marginBottom: '0.2rem' }}>
                                  <CustomNoteComponent emulator={emulator} />
                                </div> */}
                                </div>
                              </td>
                            </div>
                            <div className="align-icons">
                              {/* Icons */}
                              <td>
                                <div style={{ display: 'flex' }}>
                                  {/* calling icon */}
                                  {/* {PhoneComponent(
                                    devices,
                                    emulator,
                                    handleCallIconClicked
                                  )} */}
                                  {/* message icon */}
                                  {/* <IconButton
                                    size="small"
                                    disabled={!emulator?.user?.telephone}
                                    onClick={(e) => {
                                      e.stopPropagation()
                                      handleMessageIconClicked(emulator)
                                    }}
                                  > */}
                                  {/* <MessageRoundedIcon fontSize="small" /> */}
                                  {/* <img
                                      src={'images/gps/gps-message-icon.svg'}
                                      alt="message-icon"
                                    /> */}
                                  {/* </IconButton> */}

                                  {/* history icon */}
                                  <IconButton
                                    size="small"
                                    onClick={(e) => {
                                      e.stopPropagation()
                                      handleHistoryButtonClick(emulator)
                                    }}
                                  >
                                    <HistoryIcon fontSize="small" />
                                    {/* <img
                                      src={'images/gps/gps-history-icon.svg'}
                                      alt="message-icon"
                                    /> */}
                                  </IconButton>

                                  {/* Refresh icon */}
                                  <IconButton
                                    size="small"
                                    onClick={() =>
                                      handleRestartButtonClick(emulator)
                                    }
                                  >
                                    <RestartAltIcon fontSize="small" />
                                    {/* <img src={'images/gps/gps-referesh-icon.svg'} alt="message-icon" /> */}
                                  </IconButton>

                                  <div style={{ marginBottom: '4px' }}>
            {/* Trip Status Action */}
  {emulator.startLat !== null &&
    emulator.startLat !== undefined &&
    emulator.startLat !== 0 && (
      <IconButton
        size="small"
        onClick={(event) => handleActionButtonClick(emulator, event)} // Directly call the handler
      >
        <Tooltip title={emulator.tripStatus}>
          <div style={{ width: 20, height: 20 }}>
            {emulator.tripStatus === 'RUNNING' && (
              <PauseCircleOutlineIcon
                style={{ marginBottom: '6px' }}
                fontSize="small"
              />
            )}
            {(emulator.tripStatus === 'PAUSED' ||
              emulator.tripStatus === 'STOP' ||
              emulator.tripStatus === 'RESTING') && (
              <PlayCircleOutlineIcon
                style={{ marginBottom: '6px' }}
                fontSize="small"
              />
            )}
            {emulator.tripStatus === 'FINISHED' && (
              <CheckCircleOutlineIcon fontSize="small" />
            )}
          </div>
        </Tooltip>
      </IconButton>
    )}
</div>

                                </div>
                              </td>
                            </div>
                          </td>
                        </tr>
                      ))}
                    </tbody>
                  </table>
                )}
              />
            </div>

            <PopUpEmulatorHistory
              showToast={showToast}
              handleClose={handleHistoryClose}
              open={openEmulatorHistoryPopUp}
              emulatorHistory={selectedEmulatorForHistoryData}
            />

            <ContactDialogComponent
              contactDialogOptions={contactDialogOptions}
              setContactDialogOptions={setContactDialogOptions}
              emulators={staticEmulators}
              showToast={showToast}
            />
          </>
        </div>
        <CustomTablePagination
          onLoad={(ref) => {
            tablePaginationRef.current = ref
          }}
          rowsPerPageOptions={[1]}
          colSpan={6}
          count={emulators.length}
          rowsPerPage={rowsPerPage}
          page={page}
          onPageChange={(event, newPage) => setPage(newPage)}
          labelRowsPerPage={null}
          style={{
            overflow: 'hidden',
            borderTop: '1px solid #C8C8C8',
            position: isMobile ? 'relative' : 'absolute',
            bottom: 0,
            backgroundColor: '#fff',
            zIndex: 2,
            height: '50px',
            width: '245px',
            marginLeft: '0'
          }}
        />
      </div>
    </div>
  )
}

export default GpsTable

const blue = {
  200: '#A5D8FF',
  400: '#3399FF'
}

const grey = {
  50: '#F3F6F9',
  100: '#E7EBF0',
  200: '#E0E3E7',
  300: '#CDD2D7',
  400: '#B2BAC2',
  500: '#A0AAB4',
  600: '#6F7E8C',
  700: '#3E5060',
  800: '#2D3843',
  900: '#1A2027'
}

const CustomTablePagination = styled(TablePagination)(
  ({ theme }) => `
  & .${classes.toolbar} {
    // width: 97%;
    display: flex;
    flex-direction: row;
    align-items: center;
    // justify-content:space-around;
    gap: 0px;
    // margin: 0 5px;
    // margin: 0 -80px;
  }
  
  /* Update the select label styles */
  & .${classes.displayedRows} {
    margin: 0;
  }
  
  /* Additional styles to hide "Rows per page" label and dropdown */
  & .MuiTablePagination-actions {
    justify-content: flex-end;
    margin-left: 0;
  }

  & .MuiTypography-caption {
    display: none; // Hide the "Rows per page" label
  }

  & .MuiSelect-select {
    display: none; // Hide the dropdown
  }

  & .MuiTablePagination-select {
    display: none; // Hide the select wrapper
  }

  /* Update the select styles */
  & .${classes.select} {
    padding: 2px;
    border: 1px solid ${theme.palette.mode === 'dark' ? grey[800] : grey[200]};
    border-radius: 50px;
    background-color: transparent;
    
    &:hover {
      background-color: ${theme.palette.mode === 'dark' ? grey[800] : grey[50]};
    }
    
    &:focus {
      outline: 1px solid ${
        theme.palette.mode === 'dark' ? blue[400] : blue[200]
      };
    }
  }
  
  /* Update the displayed rows styles */
  & .${classes.displayedRows} {
    // margin-left: 2rem;
  }
  `
)
